import { render, staticRenderFns } from "./commercialProjectA.vue?vue&type=template&id=f2bbf82e&scoped=true&"
import script from "./commercialProjectA.vue?vue&type=script&lang=js&"
export * from "./commercialProjectA.vue?vue&type=script&lang=js&"
import style0 from "./commercialProjectA.vue?vue&type=style&index=0&id=f2bbf82e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bbf82e",
  null
  
)

export default component.exports